/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";

import { getTheme, IStackStyles } from "@fluentui/react";

const theme = getTheme();

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #e5e5e5;
  height: 100%;
`;

export const Main = styled.div`
  background-color: ${theme.palette.white};
  overflow: visible;
`;

export const Content = styled.div`
  padding: 10px 10px 65px 10px;
`;

export const header: Partial<IStackStyles> = {
  root: {
    height: "56px",
  },
};

export const headerContent: Partial<IStackStyles> = {
  root: {},
};

export const pageStyles: Partial<IStackStyles> = {
  root: {
    display: "flex",
    flexFlow: "row nowrap",
    height: "calc(100vh - 56px)", // Remaining height - header
    backgroundColor: "#ebebeb",
  },
};

export const sideBarStyles: Partial<IStackStyles> = {
  root: {
    height: "calc(100vh - 56px)",
    width: "200px",
  },
};

export const contentStyles: Partial<IStackStyles> = {
  root: {
    flex: "1 0 auto",
    padding: "10px",
    overflow: "auto",
  },
};
